// @flow

import React from 'react'
import { styles as s } from './style'

export default class Header extends React.Component {
  state: {
    isPackageDetailsOpen: boolean,
  }

  constructor(props: Object) {
    super(props)

    this.state = {
      isPackageDetailsOpen: false,
    }
  }

  render(): React.Element<any> {
    const { isPackageDetailsOpen } = this.state

    return (
      <div style={s.header}>
        <span style={s.headerTitle}>Order Tests</span>

        <div style={s.headerContent}>
          <span style={s.headerContentSentence}>
            Your soil will be tested by Farmers Edge Laboratories with their most &nbsp;
            <a href="" onClick={this.onPackageDetailsClick}>
              {!isPackageDetailsOpen ? 'Comprehensive Package.' : ' hide'}
            </a>
          </span>
          <span style={s.headerContentSentence}>
            Order tests for the closed job(s) below. If you have finished a sample job and do not see it in the list
            below, make sure you have closed the job and sync your mobile device.
          </span>

          <div style={isPackageDetailsOpen ? s.packageDetailsWrapper : s.detailsHide}>
            <span style={s.packageDetailsTitle}>The Test package includes:</span>
            <div style={s.packageDetailsLists}>
              <ul>
                <li style={s.listItem}>Soil pH</li>
                <li style={s.listItem}>Buffer pH</li>
                <li style={s.listItem}>Potassium</li>
                <li style={s.listItem}>Magnesium</li>
                <li style={s.listItem}>Nitrate Nitrogen</li>
                <li style={s.listItem}>Calcium</li>
                <li style={s.listItem}>Phosphorus (P1 Weak Bray and P2 Strong Bray)</li>
              </ul>
              <ul>
                <li style={s.listItem}>Sulfur</li>
                <li style={s.listItem}>Cation Exchange Capacity</li>
                <li style={s.listItem}>Organic Matter</li>
                <li style={s.listItem}>Base Saturation of Cations, B, Cu</li>
                <li style={s.listItem}>Iron</li>
                <li style={s.listItem}>Zinc</li>
                <li style={s.listItem}>Sodium and Soluble Salts</li>
              </ul>
            </div>
          </div>

          <span style={s.tableDescription}>
            Click on the job(s) you wish to order tests for and then click Place Order at the bottom of the list. *There
            is a $25 minimum charge per job.
          </span>
        </div>
      </div>
    )
  }

  onPackageDetailsClick = (e: Object) => {
    e.preventDefault()

    this.setState({
      isPackageDetailsOpen: !this.state.isPackageDetailsOpen,
    })
  }
}
